/* SET STATE */
export const SET_STATE_STATUSSAMPLE = "SET_STATE_STATUSSAMPLE"

/* STATUSSAMPLES */
export const GET_STATUSSAMPLES = "GET_STATUSSAMPLES"
export const GET_STATUSSAMPLES_SUCCESS = "GET_STATUSSAMPLES_SUCCESS"
export const GET_STATUSSAMPLES_FAIL = "GET_STATUSSAMPLES_FAIL"

/* STATUSSAMPLE */
export const GET_STATUSSAMPLE = "GET_STATUSSAMPLE"
export const GET_STATUSSAMPLE_SUCCESS = "GET_STATUSSAMPLE_SUCCESS"
export const GET_STATUSSAMPLE_FAIL = "GET_STATUSSAMPLE_FAIL"

/**
 * ADD STATUSSAMPLE
 */
 export const ADD_NEW_STATUSSAMPLE = "ADD_NEW_STATUSSAMPLE"
 export const ADD_STATUSSAMPLE_SUCCESS = "ADD_STATUSSAMPLE_SUCCESS"
 export const ADD_STATUSSAMPLE_FAIL = "ADD_STATUSSAMPLE_FAIL"

 /**
 * UPDATE STATUSSAMPLE
 */
export const UPDATE_STATUSSAMPLE = "UPDATE_STATUSSAMPLE"
export const UPDATE_STATUSSAMPLE_STATUS = "UPDATE_STATUSSAMPLE_STATUS"
export const UPDATE_STATUSSAMPLE_SUCCESS = "UPDATE_STATUSSAMPLE_SUCCESS"
export const UPDATE_STATUSSAMPLE_FAIL = "UPDATE_STATUSSAMPLE_FAIL"

/**
 * DELETE STATUSSAMPLE
 */
export const DELETE_STATUSSAMPLE = "DELETE_STATUSSAMPLE"
export const DELETE_STATUSSAMPLE_SUCCESS = "DELETE_STATUSSAMPLE_SUCCESS"
export const DELETE_STATUSSAMPLE_FAIL = "DELETE_STATUSSAMPLE_FAIL"
